import {
  CONSULTANT_CCSD_PRICING_RULE_LIST_REQUEST,
  CONSULTANT_CCSD_PRICING_RULE_LIST_RECEIVED,
  CONSULTANT_CCSD_PRICING_RULE_LIST_ERROR,
  CONSULTANT_CCSD_PRICING_RULE_LIST_UNLOAD,
  CONSULTANT_CCSD_PRICING_RULE_SINGLE_CREATE_REQUEST,
  CONSULTANT_CCSD_PRICING_RULE_SINGLE_CREATE_SUCCESS,
  CONSULTANT_CCSD_PRICING_RULE_SINGLE_UPDATE_REQUEST,
  CONSULTANT_CCSD_PRICING_RULE_SINGLE_UPDATED,
  CONSULTANT_CCSD_PRICING_RULE_SINGLE_DELETE_REQUEST,
  CONSULTANT_CCSD_PRICING_RULE_SINGLE_DELETED,
} from '../constants';

const reducer = (
  state = {
    consultantCcsdPricingRules: [],
    isFetchingConsultantCcsdPricingRules: false,
    isSavingConsultantCcsdPricingRule: false,
    isDeletingConsultantCcsdPricingRule: false,
  },
  action,
) => {
  switch (action.type) {
    case CONSULTANT_CCSD_PRICING_RULE_LIST_UNLOAD:
      return {
        ...state,
        consultantCcsdPricingRules: [],
        isFetchingConsultantCcsdPricingRules: false,
      };

    case CONSULTANT_CCSD_PRICING_RULE_LIST_REQUEST:
      return {
        ...state,
        isFetchingConsultantCcsdPricingRules: true,
      };

    case CONSULTANT_CCSD_PRICING_RULE_LIST_RECEIVED:
      return {
        ...state,
        consultantCcsdPricingRules: action.data['hydra:member'],
        isFetchingConsultantCcsdPricingRules: false,
      };

    case CONSULTANT_CCSD_PRICING_RULE_LIST_ERROR:
      return {
        ...state,
        isFetchingConsultantCcsdPricingRules: false,
      };

    case CONSULTANT_CCSD_PRICING_RULE_SINGLE_CREATE_REQUEST:
    case CONSULTANT_CCSD_PRICING_RULE_SINGLE_UPDATE_REQUEST:
      return {
        ...state,
        isSavingConsultantCcsdPricingRule: true,
      };

    case CONSULTANT_CCSD_PRICING_RULE_SINGLE_CREATE_SUCCESS:
      return {
        ...state,
        consultantCcsdPricingRules: [...state.consultantCcsdPricingRules, action.data],
        isSavingConsultantCcsdPricingRule: false,
      };

    case CONSULTANT_CCSD_PRICING_RULE_SINGLE_UPDATED:
      return {
        ...state,
        consultantCcsdPricingRules: state.consultantCcsdPricingRules.map((rule) =>
          rule.id === action.data.id ? action.data : rule,
        ),
        isSavingConsultantCcsdPricingRule: false,
      };

    case CONSULTANT_CCSD_PRICING_RULE_SINGLE_DELETE_REQUEST:
      return {
        ...state,
        isDeletingConsultantCcsdPricingRule: true,
      };

    case CONSULTANT_CCSD_PRICING_RULE_SINGLE_DELETED:
      return {
        ...state,
        consultantCcsdPricingRules: state.consultantCcsdPricingRules.filter((rule) => rule.id !== action.id),
        isDeletingConsultantCcsdPricingRule: false,
      };

    default:
      return state;
  }
};

export default reducer;
